import type { WidgetV2ListVariant } from '../../layout-variants'
import commonCss from './common.css?inline'
import listTemplate from './list/template.html?raw'
import boxesTemplate from './boxes/template.html?raw'
import slideboxTemplate from './slidebox/template.html?raw'

export function getListTemplate(variant: WidgetV2ListVariant): string {
  if (variant === 'boxes') return boxesTemplate
  if (variant === 'slidebox') return slideboxTemplate
  return listTemplate
}

export function getListCss(): string {
  return commonCss
}
